var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.$vuetify.theme.dark,"lang":_vm.$i18n.locale}},[_c('Viewer'),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }